export default __webpack_public_path__ + "static/media/IBMPlexSans-SemiBold.c15fe720.ttf";